import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import heroImg from "../images/offer-page-bg.webp";
// import winterCar from "../images/economy.png"; 
import winterCar from "../images/val-bg.png";
import truckImg from "../images/truck-van-img.png";

function Offers() {
  const navigate = useNavigate();
  const [copiedCode, setCopiedCode] = useState("");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleCopy = (code) => {
    navigator.clipboard.writeText(code);
    setCopiedCode(code);
    setTimeout(() => setCopiedCode(""), 2000);
  };

  return (
    <div className="w-full bg-white">
      {/* Hero Section */}
      <div className="mt-[58px] relative w-full h-[550px] overflow-hidden bg-white">
        <img
          src={heroImg}
          alt="Valentine Offer"
          className="w-full h-full object-cover object-right"
        />

        <div className="absolute inset-0 bg-gradient-to-r from-[#006039] via-[#006039]/40 to-transparent flex flex-col items-start justify-center text-white px-10 md:px-20">
          <div className="max-w-xl">
            <span className="bg-white/20 backdrop-blur-sm border border-white/30 px-4 py-1 rounded-sm text-xs font-bold mb-6 inline-block tracking-widest uppercase">
              Exclusive Valentine Special
            </span>
            <h1 className="text-5xl md:text-7xl font-black mb-4 tracking-tighter leading-[0.9]">
              VALENTINE'S <br />SAVINGS
            </h1>
            <p className="text-xl md:text-2xl font-light text-gray-100 mb-8 leading-relaxed">
              Take <span className="font-bold text-white underline decoration-[#ca8032] underline-offset-8">10% OFF</span> your total charges.
              Quality time with family, on the open road.
            </p>
            <button
              onClick={() => navigate("/reservation")}
              className="bg-white text-[#006039] px-12 py-4 font-bold rounded-full hover:bg-[#ca8032] hover:text-white transition-all shadow-xl uppercase text-sm tracking-wider"
            >
              Book Now
            </button>
          </div>
        </div>
      </div>

      {/* Info Section */}
      <div className="max-w-7xl mx-auto px-6 py-20 grid md:grid-cols-2 gap-12 items-center">
        <div>
          <h2 className="text-4xl md:text-5xl font-bold text-[#006039] leading-[1.1]">
            Family Friendly <br /> For Every Journey.
          </h2>
        </div>
        <div className="border-l-4 border-[#ca8032] pl-8">
          <p className="text-gray-600 text-lg leading-relaxed">
          Get 15% Off Your Next Move! Reliable trucks for your family projects or big transitions.
          </p>
        </div>
      </div>

      {/* Promo Banners Section */}
      <div className="max-w-7xl mx-auto px-6 pb-24 grid grid-cols-1 lg:grid-cols-2 gap-8">

        {/* Valentine Special Card (Green) */}
        <div className="relative group overflow-hidden rounded-3xl bg-gradient-to-br from-[#006039] to-[#008a52] text-white shadow-2xl flex flex-col justify-between min-h-[420px]">
          <div className="p-10 z-10 w-full md:w-2/3">
            <div className="flex items-center flex-nowrap gap-2 mb-6 w-full">
              <span className="text-xs font-black uppercase tracking-[0.2em] bg-black/20 px-3 py-1 rounded whitespace-nowrap">
                Valentine's Special
              </span>
              <span className="text-[10px] font-bold uppercase tracking-widest bg-[#ca8032] text-white px-3 py-1 rounded whitespace-nowrap">
                Valid until Feb 14
              </span>
            </div>
            <h3 className="text-5xl font-extrabold mb-4 tracking-tighter uppercase">Valentine's Special</h3>
            <p className="text-green-50 mb-8 text-lg opacity-90 leading-snug">
              Perfect for your next road trip with your love. Take 10% off your rental today.
            </p>

            <div
              onClick={() => handleCopy("VAL10")}
              className="relative cursor-pointer inline-flex flex-col border-2 border-dashed border-white/40 rounded-xl px-5 py-3 mb-8 hover:bg-white/10 transition-all"
            >
              <span className="text-[10px] uppercase opacity-70 font-bold tracking-widest mb-1">Click to Copy Code</span>
              <span className="text-2xl font-mono font-bold uppercase tracking-widest">VAL10</span>
              {copiedCode === "VAL10" && (
                <span className="absolute -top-10 left-1/2 -translate-x-1/2 bg-white text-[#006039] text-xs font-bold py-1 px-3 rounded shadow-xl">
                  COPIED!
                </span>
              )}
            </div>
            <br />
            <button
              onClick={() => navigate("/offer-details/valentine-special")}
              className="bg-white text-[#006039] px-8 py-3 rounded-full font-bold hover:bg-[#ca8032] hover:text-white transition-all shadow-xl uppercase text-xs tracking-widest"
            >
              Details
            </button>
          </div>
          <div className="absolute right-[-10%] bottom-0 w-3/4 pointer-events-none transform group-hover:translate-x-[-15px] transition-transform duration-700">
            <img
              src={winterCar}
              alt="Family Car"
              className="w-full h-auto object-contain drop-shadow-2xl"
              style={{
                maskImage: 'linear-gradient(to right, transparent 0%, black 25%)',
                WebkitMaskImage: 'linear-gradient(to right, transparent 0%, black 25%)'
              }}
            />
          </div>
        </div>

        {/* Truck & Van Card (Orange) */}
        <div className="relative group overflow-hidden rounded-3xl bg-gradient-to-br from-[#ca8032] to-[#b36d24] text-white shadow-2xl flex flex-col justify-between min-h-[420px]">
          <div className="p-10 z-10 w-full md:w-2/3">
            <div className="flex items-center gap-2 mb-6">
              <span className="text-xs font-black uppercase tracking-[0.2em] bg-black/20 px-3 py-1 rounded">Moving Special</span>
              <span className="text-[10px] font-bold uppercase tracking-widest bg-white text-[#ca8032] px-3 py-1 rounded">Valid until Feb 15</span>
            </div>
            <h3 className="text-5xl font-extrabold mb-4 tracking-tighter text-white">MOVE WITH LOVE</h3>
            <p className="text-orange-50 mb-8 text-lg opacity-90 leading-snug">
             Get 15% Off Your Next Move! Reliable trucks for your family projects or big transitions.


            </p>

            <div
              onClick={() => handleCopy("MOVE15")}
              className="relative cursor-pointer inline-flex flex-col border-2 border-dashed border-white/40 rounded-xl px-5 py-3 mb-8 hover:bg-white/10 transition-all"
            >
              <span className="text-[10px] uppercase opacity-70 font-bold tracking-widest mb-1">Click to Copy Code</span>
              <span className="text-2xl font-mono font-bold uppercase tracking-widest">MOVE15</span>
              {copiedCode === "MOVE15" && (
                <span className="absolute -top-10 left-1/2 -translate-x-1/2 bg-white text-[#ca8032] text-xs font-bold py-1 px-3 rounded shadow-xl">
                  COPIED!
                </span>
              )}
            </div>
            <br />
            <button
              onClick={() => navigate("/offer-details/truck-van-offer")}
              className="bg-[#006039] text-white px-8 py-3 rounded-full font-bold hover:bg-white hover:text-[#006039] transition-all shadow-xl uppercase text-xs tracking-widest"
            >
              Details
            </button>
          </div>
          <div className="absolute right-[-5%] bottom-5 w-3/4 pointer-events-none transform group-hover:translate-x-[-15px] transition-transform duration-700">
            <img src={truckImg} alt="Commercial Van" className="w-full h-auto object-contain drop-shadow-2xl" />
          </div>
        </div>

      </div>
    </div>
  );
}

export default Offers;